import { render, staticRenderFns } from "./MyPaging.vue?vue&type=template&id=4853a28c&scoped=true&"
import script from "./MyPaging.vue?vue&type=script&lang=js&"
export * from "./MyPaging.vue?vue&type=script&lang=js&"
import style0 from "./MyPaging.vue?vue&type=style&index=0&id=4853a28c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4853a28c",
  null
  
)

export default component.exports